<template>
  <div class="contact-list">
    <v-card class="top-row py-2 px-3">
      <div class="left">
        <ConatctFilters @change="onFilter" />
      </div>
      <div class="right">
        <v-btn size="large" color="primary" :to="{ name: 'ContractCreate' }">
          Skapa nya kontakt
        </v-btn>
        <div v-if="loading">
          <v-progress-circular size="25" class="mx-2" indeterminate color="#1976d2" />
        </div>
        <v-menu offset-y v-if="!loading">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-cog</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, i) in menuItems" :key="i" link :to="item.route">
              <v-icon small class="mr-2">{{ item.icon }}</v-icon>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <!-- <div class="level-2 mt-2"></div> -->
    </v-card>
    <div class="cards">
      <ContactCard
        v-for="contact in contacts"
        :key="contact.id"
        :contact="contact"
        :tags="tags"
        @add-tag="onAddTag"
        @remove-tag="onDeleteTag"
        @update-contact="onUpdateContact"
      />
    </div>
    <div>
      <Pagination v-bind="meta" @change="onPagination" show-total />
    </div>
    <router-view />
  </div>
</template>

<script>
import ContactCard from './ContactCard.vue'
import ConatctFilters from '@/components/contacts/Filters.vue'
import Pagination from '@/components/shared/Pagination.vue'

export default {
  name: 'ContactList',
  props: {
    loading: Boolean,
    contacts: Array,
    tags: Array,
    meta: Object,
  },
  components: {
    ContactCard,
    ConatctFilters,
    Pagination,
  },
  data() {
    return {
      menuItems: [
        { title: 'Hantera taggar..', route: 'tags', icon: 'mdi-tag' },
        { title: 'Exportera..', route: 'export', icon: 'mdi-export' },
      ],
    }
  },
  methods: {
    onAddTag(tag) {
      this.$emit('add-tag', tag)
    },
    onDeleteTag(tag) {
      this.$emit('remove-tag', tag)
    },
    onUpdateContact(contact) {
      this.$emit('update-contact', contact)
    },
    onFilter() {
      this.$emit('filter')
    },
    onPagination(val) {
      this.$emit('contacts:pagination', val)
    },
  },
}
</script>

<style lang="less" scoped>
.contact-list {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 0px;
}

.top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .right {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
.search-field {
  max-width: 200px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
}
</style>
